import DatePicker from "antd/lib/date-picker";
import "antd/lib/date-picker/style/css";

export default DatePicker;
